// Set the page title by replacing the default
import { useTitle } from '@vueuse/core';

export default function (title: string) {
    const currentTitle = useTitle();
    currentTitle.value = currentTitle.value.replace('List of articles', title);
}
